import type React from 'react';
import classNames from 'classnames';
import Skeleton from '../Skeleton/Skeleton';
import styles from './Card.module.css';

interface Props extends Omit<React.ComponentPropsWithoutRef<'div'>, 'title'> {
  isLoading?: boolean;
  title?: string | React.ReactElement;
  children: React.ReactNode;
  className?: string;
}

const Card = ({
  isLoading = false,
  title = '',
  children,
  className,
  ...props
}: Props): React.ReactElement =>
  isLoading ? (
    <div className={styles.component}>
      <Skeleton
        className={classNames(
          styles['content-skeleton'],
          title && styles.titled
        )}
      />
      {title && <Skeleton className={styles['title-skeleton']} />}
    </div>
  ) : (
    <div className={classNames(styles.component, className)} {...props}>
      <div className={classNames(styles.content, title && styles.titled)}>
        {children}
      </div>
      {title && <div className={styles.title}>{title}</div>}
    </div>
  );

export default Card;
